/**
 * Certificate utility functions
 */

/**
 * Generates a standardized certificate ID with letter prefix based on certificate type
 * @param {string} type - The certificate type (e.g., 'verified-mark-certificate')
 * @returns {string} A standardized certificate ID (e.g., 'V1234567')
 */
export const generateStandardCertId = (type) => {
  const prefix =
    type === 'verified-mark-certificate'
      ? 'V'
      : type === 'modified-registered-mark'
        ? 'M'
        : type === 'common-mark-certificate'
          ? 'C'
          : type === 'government-mark-certificate'
            ? 'G'
            : 'N';

  const randomNumber = Math.floor(1000000 + Math.random() * 9000000);
  return `${prefix}${randomNumber}`;
};
